import { connect } from 'react-redux';

import SearchHotkeyManager from './search_hotkey_manager.jsx';

import {
  getIsInPageSearchEnabled
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setIsInPageSearchDisplayed
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';


const mapStateToProps = (state) => {
  const isInPageSearchEnabled = getIsInPageSearchEnabled(state);
  return {
    isInPageSearchEnabled
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInPageSearchShow: () => {
      dispatch(setIsInPageSearchDisplayed(true));
    }
  };
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchHotkeyManager);
